import { EVENTS } from "@/data/content";
import { useReveal } from "@/hooks/useReveal";

export function Events() {
  const head = useReveal();
  return (
    <section id="events" data-testid="events-section" className="relative py-20 md:py-28 bg-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div ref={head.ref} className={head.className}>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-emerald-bright mb-3">Les rendez-vous</p>
          <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight max-w-3xl">
            Nos événements <span className="text-mustard">phares</span>
          </h2>
          <p className="mt-5 max-w-2xl text-cream/70 leading-relaxed">
            Tout au long de l'année, l'AJDR met la culture Hip-Hop à l'honneur avec des rendez-vous
            qui rassemblent la communauté et le public.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-12">
          {EVENTS.map((e, i) => (
            <article key={e.name} data-testid={`event-${i}`} className="group relative rounded-3xl overflow-hidden min-h-[360px] flex flex-col justify-end card-hover border border-white/5">
              <img src={e.img} alt={e.name} className="absolute inset-0 w-full h-full object-cover opacity-55 group-hover:scale-105 group-hover:opacity-75 transition-all duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-transparent" />
              <div className="relative p-7">
                <span className="tag-emerald rounded-md px-2 py-0.5 text-[10px] font-mono2 uppercase tracking-wider">{e.tag}</span>
                <h3 className="mt-3 font-display font-black text-2xl md:text-3xl text-cream">{e.name}</h3>
                <p className="mt-2 text-sm text-cream/70 leading-relaxed max-w-md">{e.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
